<template>
	
	<!-- Layout Footer -->
	<a-layout-footer>
    <!-- Copyright Notice -->
    <p class="copyright">
      Copyright © 2025
      by VIREGA.
    </p>
    <!-- / Copyright Notice -->
	</a-layout-footer>
	<!-- / Layout Footer -->

</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>
